import { Offer } from './offer.model';
import { ConfigitAceAssignment } from './configit-ace.model';
import { ConfigitAssignment } from '../components/questionnaire/configit-quest-adapter/configit-types.interface';

export enum LineType {
    primary = 'PrimaryLine',
    secondary = 'SecondaryLine',
    tertiary = 'TertiaryLine',
    product = 'ProductLine',
}

export enum ConfigitEngine {
    model = 'Model',
    ace = 'Ace',
}

export interface QuoteAssignment {
    variableName: string;
    valueName?: string;
    valueText?: string;
    isUserAssignment?: boolean;
    isDefault?: boolean;
}

interface QuotationQuoteLineBase<A extends ConfigitAssignment | ConfigitAceAssignment> {
    type: LineType;
    material: string;
    assignments: A[];
}

export interface ConfigitModelQuoteLine extends QuotationQuoteLineBase<QuoteAssignment> {
    engine: ConfigitEngine.model;
}

export interface ConfigitAceQuoteLine extends QuotationQuoteLineBase<ConfigitAceAssignment> {
    engine: ConfigitEngine.ace;
}

export type QuotationQuoteLine = ConfigitModelQuoteLine | ConfigitAceQuoteLine;

export enum QuoteStatus {
    new = 'NEW',
    quoted = 'QUOTED',
    ordered = 'ORDERED',
    expired = 'EXPIRED',
    partiallyOrdered = 'PARTIALLY_ORDERED',
}

export interface QuoteOfferExtraData {
    status: QuoteStatus;
    primarySchemes: string;
    secondarySchemes: string;
    emsScheme: string;
    energyLabelHash: string;
    externalApp?: string;
    planningType: string;
    noPriceAdvantage: boolean;
    lines: QuotationQuoteLine[];
}

export interface QuoteOffer extends Offer {
    extraData?: QuoteOfferExtraData;
}
